import React from 'react'
import { notificationMessageVar } from 'modulesCommon/store'
import { TAlert } from 'shared/types'
import { IIsaacLink } from '../../../shared/interfaces'
import * as yup from 'yup'

export const getIsaacLinkSchema = (existingIsaacLinks: IIsaacLink[]) => yup.object().shape({
  title: yup
    .string()
    .test('uniqueTitle', 'Title has already been taken.', (val): boolean => !existingIsaacLinks.find(link => link.title === val))
    .required('Title Description field is required.'),
  url: yup
    .string()
    .test('uniqueUrl', 'Url has already been taken.', (val): boolean => !existingIsaacLinks.find(link => link.url === val))
    .required('Local Isaac Link field is required.')
    .url('Please enter a valid URL.')

})

export const onNotifySuccessIssacAppend = (text: string) =>
  onNotifyAction({
    type: 'success',
    message: (
      <>
        Your ISSAC link, <b>{text}</b>, has been saved successfully.
      </>
    ),
    title: 'Success'
  })

export const onNotifySuccessIssacUpdate = (text: string) =>
  onNotifyAction({
    type: 'success',
    message: (
      <>
        Your ISSAC link, <b>{text}</b>, has been saved successfully.
      </>
    ),
    title: 'Success'
  })

export const onNotifySuccessIssacRemove = (text: string) =>
  onNotifyAction({
    type: 'success',
    message: (
      <>
        Your ISSAC link, <b>{text}</b>, has been deleted successfully.
      </>
    ),
    title: 'Success'
  })

export const onNotifySuccessIssacSave = () =>
  onNotifyAction({
    type: 'success',
    message: 'Your new ISAAC link has been successfully added.',
    title: 'Success'
  })

export const onNotifySuccessIssacDelete = () =>
  onNotifyAction({
    type: 'success',
    message: 'ISAAC link has been successfully deleted.',
    title: 'Success',
    icon: 'trash'
  })

export const onNotifyAction = (message: TAlert) => {
  notificationMessageVar(message)
}
